import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DsSpinnerModule, type DsSpinnerSize } from '@skyeng/libs/shared/ui-kit-v2/spinner';

/**
 * Небольшой индикатор ожидания в потоке страницы. Laboratory владеет публичным `lab-spinner`,
 * поэтому приложения не зависят от базового `ds-spinner` и могут получить новый визуальный
 * контракт без массовой миграции.
 */
@Component({
  selector: 'lab-spinner',
  imports: [DsSpinnerModule],
  template: '<ds-spinner color="custom" [size]="size()" />',
  styleUrls: ['./laboratory-spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.aria-hidden]': 'ariaLabel() ? null : true',
    '[attr.aria-label]': 'ariaLabel() || null',
    '[attr.role]': 'ariaLabel() ? "status" : null',
  },
})
export class LaboratorySpinnerComponent {
  readonly size = input<DsSpinnerSize>('m');
  readonly ariaLabel = input<string>();
}
